import { render, staticRenderFns } from "./PoliticaDeDados.vue?vue&type=template&id=1c19d2a7&"
import script from "./PoliticaDeDados.vue?vue&type=script&lang=js&"
export * from "./PoliticaDeDados.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports